/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CardAcceptanceMethodsError = {
  inPersonPercentage?: string | undefined;
  mailOrPhonePercentage?: string | undefined;
  onlinePercentage?: string | undefined;
};

/** @internal */
export const CardAcceptanceMethodsError$inboundSchema: z.ZodType<
  CardAcceptanceMethodsError,
  z.ZodTypeDef,
  unknown
> = z.object({
  inPersonPercentage: z.string().optional(),
  mailOrPhonePercentage: z.string().optional(),
  onlinePercentage: z.string().optional(),
});
/** @internal */
export type CardAcceptanceMethodsError$Outbound = {
  inPersonPercentage?: string | undefined;
  mailOrPhonePercentage?: string | undefined;
  onlinePercentage?: string | undefined;
};

/** @internal */
export const CardAcceptanceMethodsError$outboundSchema: z.ZodType<
  CardAcceptanceMethodsError$Outbound,
  z.ZodTypeDef,
  CardAcceptanceMethodsError
> = z.object({
  inPersonPercentage: z.string().optional(),
  mailOrPhonePercentage: z.string().optional(),
  onlinePercentage: z.string().optional(),
});

export function cardAcceptanceMethodsErrorToJSON(
  cardAcceptanceMethodsError: CardAcceptanceMethodsError,
): string {
  return JSON.stringify(
    CardAcceptanceMethodsError$outboundSchema.parse(cardAcceptanceMethodsError),
  );
}
export function cardAcceptanceMethodsErrorFromJSON(
  jsonString: string,
): SafeParseResult<CardAcceptanceMethodsError, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CardAcceptanceMethodsError$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CardAcceptanceMethodsError' from JSON`,
  );
}
